/**
 * 相关方案
 * 接入方案：https://cooper.didichuxing.com/knowledge/2203861940252/2205079857498
 * 基础能力 https://cooper.didichuxing.com/knowledge/share/book/vFvlEjjW9EVT/2202948303792
 */

import { initSCG, getSign, createAxiosInterceptor, initWsgenv } from '@didi/wsgsdk'
import config from './wsgConfig'
import { trackEvent } from '../../omega/index.js'

class Wsg {
  constructor(options) {
    const { domainList, env, bizId, wsgenvAppId, appVer, os, byQuery } = options
    this.domainList = domainList
    this.env = env
    this.bizId = bizId
    this.wsgenvAppId = wsgenvAppId
    this.appVer = appVer
    this.os = os
    this.byQuery = byQuery
    this.wsgenvInstance = null
    this.wsgenv = ''
    this.initWsgSDK()
    this.initWsgenvSDK()
  }

  initWsgSDK() {
    try {
      // 挑战应答
      initSCG({
        domainList: this.domainList,
        env: this.env,
        bizId: this.bizId,
        appVer: this.appVer,
        os: this.os,
        byQuery: this.byQuery,
      })
    } catch (error) {}
  }

  initWsgenvSDK() {
    if (!this.wsgenvAppId) return
    try {
      this.wsgenvInstance = initWsgenv({
        appId: this.wsgenvAppId,
        env: this.env,
      })
    } catch (error) {}
  }

  getWsgenv() {
      try {
        this.wsgenvInstance.wsgParams(
          {
            url: 'https://H5_common',
          },
          wsgenv => {
            this.wsgenv = wsgenv || ''
          },
        )
      } catch (error) {
        this.wsgenv = ''
      }

    return this.wsgenv
  }

  /**
   * https://cooper.didichuxing.com/knowledge/share/page/KEwPyXFLee7Y
   * params: params, //如果没有请求参数，则不用传params参数
   * body: body, //如果没有请求体，则不用传body参数
   * contentType: contentType, //如果没有请求体，则也没有请求体的数据类型，故contentType参数也不用传
   * signUpgrade: true, // 涉及计算签名耗时相关，见下一章节性能章节，(boolean类型：true或false，建议此参数必传，不要使用默认值)
   * @param {Object} params
   * @returns {String} 签名
   */
  getSign(params) {
    try {
      return getSign(params)
    } catch (error) {}
  }

  wsgsigHandler(config) {
    const wsgsigHandler = createAxiosInterceptor({
      // 决定签名在请求哪个位置携带，可选值：'query'、'header'，非必传，默认值：'query'
      placement: 'query',
    })
    return wsgsigHandler(config)
  }

  trackEvent(error) {
    trackEvent({
      eventId: 'tech_page_request_send',
      eventLabel: '请求触发埋点',
      attrs: {
        href: window.location.href || '',
        url: error.config.url || '',
        success: 0,
        reason: error.message || '501',
      },
    })
  }

  // axios error 对象
  exceptionHandler(error) {
    const wsgErrCode = 501
    // code 为 501 时上报埋点
    if (error.message.includes(wsgErrCode)) {
      this.trackEvent(error)
    }
  }
}

export default new Wsg(config.online)